export function getTranslatedPreliminaryStatus(
  status: string,
  t: (key: string) => string
): string {
  let statusTranslated = status;

  if (status === "pending") {
    statusTranslated = t("pending");
  } else if (status === "in_progress") {
    statusTranslated = t("inProgress");
  } else if (status === "completed") {
    statusTranslated = t("completed");
  } else if (status === "needs_investigation") {
    statusTranslated = t("needsInvestigation");
  } else if (status === "no_issue_found") {
    statusTranslated = t("noIssueFound");
  } else if (status === "caseAssigned") {
    statusTranslated = t("caseAssigned");
  } else if (status === "underInvestigation") {
    statusTranslated = t("underInvestigation");
  } else if (status === "reportDrafting") {
    statusTranslated = t("reportDrafting");
  } else if (status === "reportReview") {
    statusTranslated = t("reportReview");
  } else if (status === "closed") {
    statusTranslated = t("closed");
  }

  return statusTranslated;
}
